import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/jqn/",
  routes: [
    {
      path: "/",
      redirect: "/recordlist",
      meta: {
        title: "聆记",
        keepAlive: false, // 此组件不需要被缓存
        isBack: false, // 用于判断上一个页面是哪个
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/jqn/login.vue"),
      meta: {
        title: "登录",
      },
    },
    {
      path: "/recordlist",
      name: "recordlist",
      component: () => import("@/views/jqn/RecordList.vue"),
      meta: {
        title: "聆记",
      },
    },
    {
      path: "/recording",
      name: "recording",
      hidden: true,
      component: () => import("@/views/jqn/JqnRecording.vue"),
      meta: {
        title: "聆记",
        pageReturn: true,
        KeepAlive: false,
      },
    },
    {
      path: "/recorddetails/:recordId",
      name: "recorddetails",
      hidden: true,
      component: () => import("@/views/jqn/RecordDetails.vue"),
      meta: {
        title: "聆记",
        pageReturn: true,
      },
    },
    {
      path: "/previewDoc/:type",
      name: "previewDoc",
      hidden: true,
      component: () => import("@/views/jqn/previewDoc.vue"),
      meta: {
        title: "聆记",
        pageReturn: true,
      },
    },
    {
      path: "/docs/:type",
      name: "docs",
      hidden: true,
      component: () => import("@/views/jqn/jqnDocs.vue"),
      meta: {
        title: "聆记",
        pageReturn: true,
      },
    },
    {
      path: "/none",
      name: "none",
      hidden: true,
      component: () => import("@/views/jqn/noResult.vue"),
      meta: {
        title: "聆记",
        pageReturn: true,
      },
    },
    {
      path: "/download",
      name: "download",
      hidden: true,
      component: () => import("@/views/jqn/downLoad.vue"),
      meta: {
        title: "聆记",
        pageReturn: true,
      },
    },
    {
      path: "/personalCenter",
      name: "personalCenter",
      hidden: true,
      component: () => import("@/views/jqn/PersonalCenter/PersonalCenter.vue"),
      meta: {
        title: "个人中心",
        pageReturn: true,
      },
    },
    {
      path: "/interstitialPage",
      name: "interstitialPage",
      hidden: true,
      component: () => import("@/views/jqn/InterstitialPage.vue"),
      meta: {
        title: "聆记",
        pageReturn: true,
      },
    },
  ],
});
